module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/landing-pages-ferris-wheel-25c96bc40682fdcba96240f6c37bbaae.svg";